import { Skeleton } from "@/components/ui/skeleton";
import { TradesmenLogo } from "@/components/tradesman/tradesmen-logo";

export function LoadingSkeleton() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-emerald-50 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950">
      <div className="bg-gradient-to-r from-emerald-800 via-emerald-700 to-emerald-800 dark:from-emerald-950 dark:via-emerald-900 dark:to-emerald-950 text-white py-16 shadow-xl dark:shadow-emerald-950/50">
        <div className="container mx-auto px-4">
          <div className="flex flex-col items-center mb-6">
            <div className="mb-6 w-32 h-32">
              <TradesmenLogo className="w-full h-full opacity-50" />
            </div>
            <Skeleton className="h-14 w-[500px] mx-auto mb-4 bg-white/20 dark:bg-white/10" />
            <Skeleton className="h-7 w-[600px] mx-auto bg-white/10 dark:bg-white/5" />
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 py-8">
        <Skeleton className="h-12 w-64 mb-4 bg-slate-200 dark:bg-slate-800" />
        <div className="flex flex-wrap gap-2 mb-8">
          {[1, 2, 3, 4, 5].map((i) => (
            <Skeleton key={i} className="h-11 w-36 bg-slate-200 dark:bg-slate-800" />
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <Skeleton key={i} className="h-[280px] rounded-xl bg-slate-100 dark:bg-slate-800" />
          ))}
        </div>
      </div>
    </div>
  );
}